module.exports = __webpack_public_path__ + "static/MYSLENIE-PRE-ZIVOT-a391535a58c260d038619c107c9801df.png";